import { render, staticRenderFns } from "./ProfileOnboarding.vue?vue&type=template&id=e1591ffa&"
import script from "./ProfileOnboarding.vue?vue&type=script&lang=js&"
export * from "./ProfileOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports